import { render } from "./StoreCountControl.vue?vue&type=template&id=1615fef5"
import script from "./StoreCountControl.vue?vue&type=script&lang=js"
export * from "./StoreCountControl.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__